var findIndex = require('../array/virtual/find-index');

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.findIndex;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.findIndex) ? findIndex : own;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/instance/find-index.js
// module id = 988
// module chunks = 0